var constants = {
    ENTER_KEY: 'Enter'
};
var Constants = Object.freeze(constants);

export default Constants;